<template>
  <div v-show="visible" class="pop-container" :style="{top: valueY+'px', left: (valueX+20)+'px'}">
    <slot />
  </div>
</template>

<script>
import '../../../../lib/styles/components/Pop.scss'
export default {
  name: 'Pop',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    valueX: {
      type: Number,
      default: 0
    },
    valueY: {
      type: Number,
      default: 0
    }
  }
}
</script>
